import { Fragment, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import "./NcertTestScreen.css";

import { fetchChapterData } from "../../../../redux/chapter/chapterSlice";

import Heading from "./components/Heading/Heading";

import ProgressBar from "./components/ProgressBar/ProgressBar";

import Chapter from "./components/Chapter/Chapter";

import { useHistory, useLocation } from "react-router-dom";

import Header_component from "../../structure_components/desktop_screens/header_component/header_component";

const NcertTestScreen = () => {
  const dispatch = useDispatch();

  const navigate = useHistory();

  const location = useLocation();

  const [darkMode, setDarkMode] = useState(false);

  const [showHeader, setShowHeader] = useState(true);

  const chapter_id = location?.state?.chapter_id;

  const action = location?.state?.action;

  const { chapter_info, user_progress, loading } =
    useSelector((state) => state.chapter) || {};

  const read_mode_params = action === "read_mode" ? "1" : "0";

  useEffect(() => {
    if (chapter_id) {
      dispatch(fetchChapterData({ chapter_id }));
    }
  }, [dispatch, chapter_id]);

  const total = chapter_info?.total_qn_blanks || 0;

  if (loading) return <div className="spinner" />;

  return (
    <Fragment>
      <Header_component />

      <div
        className={`sticky-header-container ${darkMode ? "dark" : "light"} ${
          !showHeader ? "hidden" : ""
        }`}
      >
        {showHeader && (
          <>
            <Heading
              title={chapter_info?.chapter_name}
              onBack={() => navigate.push("/ncert")}
              darkMode={darkMode}
              setDarkMode={setDarkMode}
            />

            {read_mode_params !== "1" && (
              <ProgressBar
                total={total}
                userProgress={user_progress}
                label="Progress"
                darkMode={darkMode}
              />
            )}
          </>
        )}
      </div>

      <div className="chapter-section container-lg container-fluid">
        <Chapter
          darkMode={darkMode}
          onPracticeCompleted={() => setShowHeader(false)}
        />
      </div>
    </Fragment>
  );
};

export default NcertTestScreen;
